import { MutationTree } from 'vuex'
import { State, Campaign } from './state'

export enum MutationType {
    SetData = 'SET_DATA',
    SetLoading = 'SET_LOADING',
    SetSound = 'SET_SOUND',
    SetReset = 'SET_RESET',
    SetVersion = 'SET_VERSION',
    SetSection = 'SET_SECTION',
    SetCategories = 'SET_CATEGORIES'
}

export type Mutations = {
    [MutationType.SetData](state: State, tasks: Campaign[]): void;
    [MutationType.SetLoading](state: State, value: boolean): void;
    [MutationType.SetSound](state: State, value: boolean): void;
    [MutationType.SetReset](state: State, value: string[]): void;
    [MutationType.SetVersion](state: State, value: number[]): void;
    [MutationType.SetSection](state: State, value: number[]): void;
    [MutationType.SetCategories](state: State, value: string[]): void;
}

export const mutations: MutationTree<State> & Mutations = {
    [MutationType.SetData](state, data) {
        state.data = data
    },
    [MutationType.SetLoading](state, value) {
        state.loading = value
        // console.log("Loading data...")
    },
    [MutationType.SetSound](state, value) {
        state.sound = value
        // console.log(`Sound ${value}`)
    },
    [MutationType.SetReset](state, value) {
        state.reset = value
    },
    [MutationType.SetVersion](state, value) {
        state.regions = value
    },
    [MutationType.SetSection](state, value) {
        state.sections = value
    },
    [MutationType.SetCategories](state, value) {
        state.categories = value
    },
}